
import { resolveUrl } from '@shared/lib/url'
import { AppRoute } from '@shared/config'

import { useTutorBillingReturnStore } from '../model/store'
import { TUTOR_BILLING_BACK_QUERY } from '../config/tutor-billing-return'

export const resolveTutorBillingReturnPath = (path: string | null): string => {
  if (!path) return AppRoute.BillingTutorInfo

  const isListPath = path === AppRoute.BillingTutorInfo
    || path.startsWith(`${AppRoute.BillingTutorInfo}?`)
    || path.startsWith(`${AppRoute.BillingTutorInfo}#`)

  return isListPath ? path : AppRoute.BillingTutorInfo
}

export const navigateToTutorLegal = async (tutorId: number): Promise<void> => {
  const route = useRoute()

  useTutorBillingReturnStore().setReturnPath(route.path === AppRoute.BillingTutorInfo ? route.fullPath : null)

  await navigateTo({
    path: resolveUrl(AppRoute.TutorsLegal, { id: tutorId }) ?? '',
    query: { back: TUTOR_BILLING_BACK_QUERY },
  })
}
